/* 签章数据缓存（单个文件签章数据） */
/* 加入保证金数据 marginMoney */
export default {
    state:{
		sealList:[],
		py:null,
		sort: 1, //
		marginMoney: 1, // 1为保证金申请， 2为保证金管理
		deposit: {
			depositProcess: 0, // 0.保证金缴纳申请 1.缴纳凭证 2.保证金退还申请 3.退还凭证
			depositName: null, // 保证金名称
			depositId: null, // 保证金Id
			depositApprovel: null, // 是否回填保证金详情
		},
		detailsData: {}, // 详情数据跳转存放
		projectHistoryIndex: 1,
		ganttLeft: 0, // 进度解析左侧树状图判断是否有改变
		ganttLeftNum: [], // 进度解析左侧树状图点击是具体ID
		compileNum: 0,
		ganttTree: {},
		ganttUpdate: 0
    },
    mutations:{
    	sealListS(state,val){
    		state.sealList=val
    	},
    	sortS(state,txt){
    		state.sort=txt
		},
		addType(state,val){
			state.py = val
		},
		compileNum(state,val){
			state.compileNum = val
		}
    },
    actions:{

    },
    getters:{
    	// messageNum:function(state){
    		// return state.login_mes.message
    	// }
    },
}



// WEBPACK FOOTER //
// ./src/store/sealData.js